import { FaqStructureUrlFactory } from "@factory/FaqStructureFactory";

import { FaqStructureType_faqCollection_items } from "globalQueries/contentfulTypes/FaqStructureType";
import { UrlStructureItem } from "types/UrlStructureItem";

export const mappedFaqUrlStructure = (
  items: Array<FaqStructureType_faqCollection_items>,
): UrlStructureItem[] => {
  return items?.length ? FaqStructureUrlFactory(items) : ({} as UrlStructureItem[]);
};
